<template>
  <div class="top-item">
    <div class="item-padding">
      <div class="top-container">
        <div class="item-day-info">
          <!-- <div class="day-right">
                        <span class="day-tips">签到提醒</span>
                        <van-switch v-model="openSignTips" active-color="#27CE5F" @change="bindChangeSignTips"
                            :loading="disabledToggle" inactive-color="rgba(0,0,0,0.12)" size="18px" />
                        <div class="sign-flag" :class="{ 'sign-flag-animate': showSignTips }"
                            v-show="!openSignTips && showSignTips">
                            <div class="flag-text">开启提醒，永不错过！</div>
                        </div>
                    </div> -->
        </div>
        <div class="sign-in-days">
          <div v-if="data.user_plan_state == 1"
            >“恭喜您！60天打卡挑战成功🎉”</div
          >
          <div v-else-if="data.user_plan_state == 2"
            >“您未连续打卡，挑战失败😭”</div
          >
          <div v-else
            >“您已连续打卡 <span class="pink">{{ data.day_num }}</span> 天”</div
          >
        </div>
        <div v-clickBuried data-click-buried="CLICK_VIP_HD_0YDK_DK_2">
          <div
            class="sign-btn"
            v-if="data.user_plan_state == 1"
            @click="bindSuccess"
            >前往返现
          </div>
          <div
            class="sign-btn"
            v-else-if="data.user_plan_state == 2"
            @click="bindError"
            >领取福利
          </div>
          <div v-else>
            <div class="sign-btn" v-if="!data.is_sign" @click="bindSign"
              >立即打卡
              <img
                class="btn-animate"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/017fb04af8e1483ef0730edbb4b2d2f7.png"
                alt=""
              />
            </div>
            <div class="sign-btn sign-btn-active" v-else>打卡成功</div>
          </div>
        </div>
        <div
          class="desc"
          v-if="![1, 2].includes(data.user_plan_state) && !data.is_sign"
          >点击按钮，跳转至「体重打卡」<br />
          *体重打卡必须手动填写数据才算打卡成功</div
        >
        <img
          class="tips-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f2501d48138698340a4128847a9e8c84.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Calendar } from '@/common/calendar.js'
import dataObj from '@/common/date.js'
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      disabledToggle: false,
      checked: false,
      openSignTips: false,
      showSignTips: false,
      calendarData: { calendarName: '0元得we+会员年卡' },
      hours: 10 //每天10点
    }
  },
  created() {
    this.init()
  },
  mounted() {
    setTimeout(() => {
      this.showSignTips = true
    }, 600)
  },
  methods: {
    bindSign() {
      this.$emit('sign')
    },
    bindSuccess() {
      this.$emit('success')
    },
    bindError() {
      this.$emit('error')
    },
    //切换推送
    bindChangeSignTips() {
      if (this.openSignTips) {
        this.updateSignTips(this.data, this.hours, true)
      } else {
        this.Calendar.delCalendar()
          .then(() => {
            this.$toast('签到提醒已关闭')
          })
          .catch((e) => {
            this.$toast((e && e?.message) || '关闭失败')
            this.openSignTips = true
          })
      }
      this.disabledToggle = true
      setTimeout(() => {
        this.disabledToggle = false
      }, 2000)
    },
    setCalendarDays() {},
    init() {
      this.Calendar = new Calendar(this.calendarData)
      this.Calendar.haveCalendar(this.calendarData.calendarName)
        .then((res) => {
          this.openSignTips = res
          if (this.openSignTips) {
            this.updateSignTips(this.data, this.hours)
          }
        })
        .catch((e) => {
          this.openSignTips = false
        })
    },
    /* 每天更新用户的日历行程  */
    updateSignTips(signInfo, hours, isToast) {
      this.Calendar.delCalendar()
        .then((res) => {})
        .catch(() => {})
        .finally(() => {
          let addDay = signInfo.sign_task.length - signInfo.continuous_day
          let overDay = signInfo.is_sign
            ? signInfo.over_day
            : signInfo.over_day + 1
          addDay = addDay < overDay ? addDay : overDay
          let list = this.getTimeStrList(signInfo.is_sign, addDay, hours)
          this.Calendar.bindSetCalendar(list)
            .then(() => {
              isToast && this.$toast('签到提醒已开启')
            })
            .catch(() => {
              isToast && this.$toast('开启失败')
              this.openSignTips = false
            })
        })
    },
    /* 获取时间字符串列表*/
    getTimeStrList(isSign, addDay, hours) {
      let list = []
      let todayZeroTime = new Date(new Date().toLocaleDateString()).getTime()
      let calendarTime = todayZeroTime + hours * 1000 * 60 * 60
      let dayTime = 1000 * 60 * 60 * 24
      if (isSign) {
        calendarTime = calendarTime + dayTime
      }
      for (let i = 0; i < addDay; i++) {
        let curTime = calendarTime + i * dayTime
        list.push(dataObj.getFullTimeStr(curTime))
      }
      return list
    }
  }
}
</script>
<style lang="scss" scoped>
.item-padding {
  padding: 0px 7px 0px;
  border-radius: 0px 0px 16px 16px;
  margin-top: -10px;
}

.top-item {
  color: rgba(0, 0, 0, 0.8);
  margin-bottom: 61px;
  border-style: solid;
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 20px;
  border-bottom-width: 20px;
  border-image-source: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/33c32071d346077825362b29fdf00ae6.png');
  border-image-slice: 60 0 60 0 fill;
  border-image-width: 20px 0 20px 10;
}

.top-container {
  padding: 0px 9px 5px;
}

.item-day-info {
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-end;

  .day-right {
    position: relative;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    color: rgba(0, 0, 0, 0.49);
    display: flex;
    align-items: center;

    .sign-flag {
      width: 0;
      height: 0;
      border-bottom: 0px solid transparent;
      border-top: 4px solid rgb(153, 153, 153);
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      position: absolute;
      left: 38%;
      bottom: 110%;

      .flag-text {
        padding: 2px 0px 0px 6px;
        font-size: 9px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        line-height: 16px;
        color: #ffffff;
        white-space: nowrap;
        left: 50%;
        bottom: 2px;
        transform: translate(-50%, 0%);
        position: absolute;
        height: 18px;
        border-radius: 9px;
        background-color: rgb(153, 153, 153);
      }
    }

    .sign-flag-animate {
      animation: myOpacity 1s linear;
    }

    .day-tips {
      margin-right: 3px;
    }

    ::v-deep .van-switch {
      width: 31px;
      border: none;

      .van-switch__node {
        width: 0.77em;
        height: 0.77em;
        left: 2px;
        top: 2px;
      }
    }

    ::v-deep .van-switch--on {
      .van-switch__node {
        transform: translateX(0.7em);
      }
    }
  }
}

.sign-btn {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: rgba(255, 103, 32, 1);
  border-radius: 25px;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  margin-bottom: 8px;
  position: relative;
  overflow: hidden;

  .btn-animate {
    position: absolute;
    left: 60%;
    top: 50%;
    width: 80px;
    transform: translate(0%, -50%) skewX(-30deg);
    animation: lightAnimate 2.6s linear infinite;
  }
}

.sign-btn-active {
  background: rgba(255, 239, 232, 1);
  color: rgba(255, 103, 32, 1);
}

@keyframes lightAnimate {
  0% {
    left: -5%;
  }

  70% {
    left: 105%;
  }

  100% {
    left: 105%;
  }
}

.desc {
  text-align: center;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 18px;
}

.sign-in-days {
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 11px;

  .pink {
    color: rgba(255, 103, 32, 1);
  }
}

.disabled-sign-btn {
  text-align: center;
  margin: 0 auto;
  width: 268px;
  height: 48px;
  background: #cccccc;
  border-radius: 26px;
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 48px;
}
.tips-image {
  width: 100%;
  height: 60px;
}
@keyframes scaleAnimate {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.05);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes myOpacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
